import axios from 'axios'
import { BUSCAR_ITINERARIOS_FUTURO } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';
import { montarURLFiltro } from '../../util/filtros';

export default function buscarItinerariosFuturo(codigo, codigoRota, pagina, registrosPorPagina, filtros) {

  const urlFiltros = montarURLFiltro(filtros, pagina, registrosPorPagina);

  let url = `${URL}/itinerario/empresa/${codigo}/rota/${codigoRota}/itinerarios/${urlFiltros}`;

  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
    response => dispatch({
      type: BUSCAR_ITINERARIOS_FUTURO,
      payload: response
    })
  );
}